<section
  class="landing-a__section landing-a__features-section"
  id="features"
  appLandingReveal="landing-a__features-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__section-heading">
      <h2>{{ 'landing.landing_1.features.title' | translate }}</h2>
      <p>{{ 'landing.landing_1.features.subtitle' | translate }}</p>
    </div>

    <div class="landing-a__features-grid">
      @for (feature of features; track feature.titleKey) {
        <article class="landing-a__feature-card">
          <div class="landing-a__feature-header">
            <div class="landing-a__feature-icon">
              <i-tabler [name]="feature.icon"></i-tabler>
            </div>
            <h3>{{ feature.titleKey | translate }}</h3>
          </div>
          <p>{{ feature.descriptionKey | translate }}</p>
        </article>
      }
    </div>
  </div>
</section>
